import { Control } from '../../business-objects/control/control.model';
import { SelectControlConfig } from './select-control-config.model';

export class SelectControl extends Control {
    config: SelectControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/select/select-control.model.ts